import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, FormGroup, Row, Form, Input } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import Breadcrumbs from "../../../layout/breadcrumb";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import withReducer from "../../../store/withReducer";
import orderReducer from "../store";
import { getEuOrders } from "../store/orderSlice";
import PreLoader from "../../../share-components/ui/preLoader";
import BackInStockTable from "../../backInStock/content/backInStockTable";

const { afterToday } = DateRangePicker;

const ORDER_STATES = [
  { value: 'WAITING_ACCEPTANCE', label: 'Waiting Acceptance' },
  { value: 'WAITING_DEBIT', label: 'Waiting Debit' },
  { value: 'WAITING_DEBIT_PAYMENT', label: 'Waiting Debit Payment' },
  { value: 'SHIPPING', label: 'Shipping' },
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'TO_COLLECT', label: 'To Collect' },
  { value: 'RECEIVED', label: 'Received' },
  { value: 'CLOSED', label: 'Closed' },
  { value: 'REFUSED', label: 'Refused' },
  { value: 'CANCELED', label: 'Canceled' },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

function EuOrders() {
  const history = useHistory();
  const dispatch = useDispatch();
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [timer, setTimer] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [sku, setSku] = useState(null);
  const [orderState, setOrderState] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [startDate, endDate] = dateRange;
  const orderStore = useSelector(({ order }) => order.order);

  useEffect(() => {
    getData();
  }, [dispatch, startDate, endDate, page, pageSize, orderNumber, sku, orderState]);

  const getData = () => {
    setLoading(true);
    const data = {
      page,
      pageSize,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      ...(orderNumber ? { order_number: orderNumber } : {}),
      ...(sku ? { sku } : {}),
      ...(orderState ? { order_state: orderState.value } : {}),
    };
    dispatch(getEuOrders(data)).then(() => setLoading(false));
  };

  const dataMenu = [{ type: 0, text: "ASOS EU Orders" }];

  const stateColor = {
    SHIPPING: 'primary', SHIPPED: 'success', CLOSED: 'secondary',
    CANCELED: 'danger', RECEIVED: 'info',
  };

  const tableColumns = [
    {
      name: "Mirakl Order No",
      selector: (row) => row.mirakl_order_number,
      sortable: true,
      center: false,
      width: "200px",
    },
    {
      name: "Shopify Order",
      selector: (row) => row.shopify_order_name || row.shopify_order_number || "—",
      sortable: true,
      center: false,
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
    },
    {
      name: "Status",
      selector: (row) => row.order_state,
      sortable: true,
      center: false,
      cell: (row) => (
        <span className={`badge bg-${stateColor[row.order_state] || 'secondary'}`}>
          {row.order_state}
        </span>
      ),
    },
    {
      name: "Fulfilment",
      selector: (row) => row.fulfilment_status,
      sortable: true,
      center: false,
    },
    {
      name: "Total Price",
      selector: (row) => row.total_price,
      sortable: true,
      center: false,
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      center: false,
    },
    {
      name: "Country",
      selector: (row) => row.country_code,
      sortable: true,
      center: false,
    },
    {
      name: "Action",
      center: true,
      width: "100px",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          style={{ whiteSpace: "nowrap" }}
          onClick={() => history.push(`${process.env.PUBLIC_URL}/order/eu-orders/${row.id}`)}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumbs title="ASOS EU Orders" data={dataMenu} />

      <Container fluid={true} className="product-wrapper">
        <div className="product-grid">
          <div className="feature-products">
            <Row className="mb-2">
              <Col sm="2">
                <div className="dashboard-datepicker">
                  <DatePicker
                    dateRange={dateRange}
                    dateRangeChange={(date) => setDateRange(date)}
                    defaultValue={[TodayDate, sevenDays]}
                    disabledDate={afterToday()}
                    paddingLeft={10}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <FormGroup>
                  <Select
                    placeholder={<div>Order Status</div>}
                    getOptionLabel={(o) => o.label}
                    getOptionValue={(o) => o.value}
                    className="select2-filter"
                    isClearable
                    styles={customStyles}
                    options={ORDER_STATES}
                    onChange={(e) => setOrderState(e || null)}
                    components={{ IndicatorSeparator: () => null }}
                  />
                </FormGroup>
              </Col>

              <Col sm="3">
                <Form onSubmit={(e) => e.preventDefault()}>
                  <FormGroup className="m-0">
                    <Input
                      name="search"
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        clearTimeout(timer);
                        const t = setTimeout(() => setOrderNumber(e.target.value), 500);
                        setTimer(t);
                      }}
                      placeholder="Search Order Number"
                    />
                    <i className="fa fa-search"></i>
                  </FormGroup>
                </Form>
              </Col>

              <Col sm="3">
                <Form onSubmit={(e) => e.preventDefault()}>
                  <FormGroup className="m-0">
                    <Input
                      name="sku"
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        clearTimeout(timer);
                        const t = setTimeout(() => setSku(e.target.value), 500);
                        setTimer(t);
                      }}
                      placeholder="Search SKU"
                    />
                    <i className="fa fa-search"></i>
                  </FormGroup>
                </Form>
              </Col>
            </Row>

            <Row>
              <Col sm="12" className="mt-3">
                <Card>
                  <CardBody>
                    {loading ? (
                      <div style={{ minHeight: 400 }}>
                        <PreLoader />
                      </div>
                    ) : (
                      <div className="table-responsive product-table">
                        <BackInStockTable
                          paginationTotalRows={orderStore.euTableRow}
                          idArray={{ idArray: [] }}
                          selectableRows={false}
                          tableColumns={tableColumns}
                          backStockData={orderStore.euData || []}
                          backInRequestState={orderStore}
                          pageChange={(p) => setPage(p)}
                          onPageSizeChange={(ps) => setPageSize(ps)}
                          paginationRowsPerPageOptions={[10, 25, 50, 100]}
                          paginationDefaultPage={page}
                          paginationPerPage={pageSize}
                          progressPending={loading}
                        />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </Fragment>
  );
}

export default withReducer([{ order: orderReducer }])(EuOrders);
